module.exports = __webpack_public_path__ + "fe9dbd61b4dc89b1e18ad360088f097e.jpg";